import { utilBuildings } from "../../../utils/utilBuildings";
import { selectBuildingsProducingOrFinishedProductionResourceAvailable } from "../selectors/selectBuildingsProducingOrFinishedProductionResourceAvailable";
export var checkAnyBuildingWhichProducesResourceIdProductionDoneAvailable = function (path) { return function (action, state$, dependencies) {
    var state = state$.value;
    var resourceId = action.taskType.resourceId;
    var availableBuildings = selectBuildingsProducingOrFinishedProductionResourceAvailable(state, resourceId);
    var buildingsWithProductionFinished = availableBuildings.some(utilBuildings.hasFinishedProduction);
    return buildingsWithProductionFinished ? path : undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/checks/checkAnyBuildingWhichProducesResourceIdProductionDoneAvailable.ts
// module id = 2356
// module chunks = 3